export default __webpack_public_path__ + "static/media/noise.8d83c8e8.png";